import React, { useMemo } from 'react'
import { Checkbox } from '@blueprintjs/core'
import { TaskT } from 'ui-io/task-io/task-t'

import { TaskCellProps } from './task-cell'

const TaskSelectCell = ({
  task,
  onTasksSelect,
  selectedTasks,
}: TaskCellProps) => {
  const isSelected = useMemo(
    () => selectedTasks?.some(({ id }) => id === task.id),
    [task, selectedTasks],
  )

  return onTasksSelect ? (
    <Checkbox
      checked={isSelected}
      onClick={() => onTasksSelect([task], !isSelected)}
    />
  ) : null
}

export const SelectAllTask = ({
  tasks,
  onTasksSelect,
  selectedTasks,
}: {
  tasks: TaskT[]
  onTasksSelect: (task: TaskT[], selected: boolean) => void
  selectedTasks: TaskT[]
}) => {
  const isSelected = selectedTasks.length === tasks.length
  return onTasksSelect ? (
    <Checkbox
      checked={isSelected}
      onClick={() => onTasksSelect(tasks, !isSelected)}
    />
  ) : null
}

export default TaskSelectCell
